(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JslibHtml5CameraPhoto", [], factory);
	else if(typeof exports === 'object')
		exports["JslibHtml5CameraPhoto"] = factory();
	else
		root["JslibHtml5CameraPhoto"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACING_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMAGE_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MediaServices__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CameraPhoto__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CameraPhoto__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__MediaServices__["b"]; });



var FACING_MODES = __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a" /* MediaServices */].FACING_MODES;
var IMAGE_TYPES = __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a" /* MediaServices */].IMAGE_TYPES;

// For debugging only


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MediaServices__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(2);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__helper__["a"]; });



/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getImageSize;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDataUri;
/* harmony export (immutable) */ __webpack_exports__["e"] = hasConstraints;
/* harmony export (immutable) */ __webpack_exports__["d"] = getIsIOS;
/* harmony export (immutable) */ __webpack_exports__["a"] = _getDebugPlatformInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(3);


function _validateImgParam(imageType, imageCompression) {
  // validate the imageCompression
  if (!(imageCompression >= 0 && imageCompression <= 1)) {
    throw new Error(imageCompression + ' is invalid imageCompression, choose between: [0, 1]');
  }

  // validate the imageType
  if (!__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SUPPORTED_IMAGE_TYPES */].includes(imageType)) {
    throw new Error(imageType + ' is invalid imageType, choose between: ' + __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SUPPORTED_IMAGE_TYPES */].join(', '));
  }
  return true;
}

function _getValidImgParam(imageType, imageCompression) {
  var imgParam = {};
  try {
    _validateImgParam(imageType, imageCompression);
    imgParam.imageType = imageType;
    imgParam.imageCompression = imageCompression;
  } catch (e) {
    console.error(e);
    console.error('default value of ' + __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* IMAGE_TYPES */].PNG + ' is used');

    imgParam.imageType = __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* IMAGE_TYPES */].PNG;
    imgParam.imageCompression = null;
  }

  return imgParam;
}

function _getStringWithPlatform() {
  // platform will be obsolete and will return empty string
  var platform = window.navigator.platform;
  var userAgent = window.navigator.userAgent;

  return platform || userAgent;
}

function getImageSize(videoWidth, videoHeight, sizeFactor) {
  // calc the imageWidth
  var imageWidth = videoWidth * parseFloat(sizeFactor);
  // calc the ratio
  var ratio = videoWidth / imageWidth;
  // calc the imageHeight
  var imageHeight = videoHeight / ratio;

  return {
    imageWidth: imageWidth,
    imageHeight: imageHeight
  };
}

function getDataUri(canvas, imageType, imageCompression) {
  var imgParam = _getValidImgParam(imageType, imageCompression);

  if (imgParam.imageType === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* IMAGE_TYPES */].JPG) {
    if (!imageCompression) {
      return canvas.toDataURL(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FORMAT_TYPES */][__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* IMAGE_TYPES */].JPG]);
    }
    return canvas.toDataURL(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FORMAT_TYPES */][__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* IMAGE_TYPES */].JPG], imageCompression);
  }

  return canvas.toDataURL(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FORMAT_TYPES */][imageType]);
}

function hasConstraints(idealCameraDevice, idealResolution) {
  return idealCameraDevice || idealResolution;
}

// Inspiration: https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
function getIsIOS() {
  var stringWithPlatform = _getStringWithPlatform();

  if (stringWithPlatform.match(/iPad/i) || stringWithPlatform.match(/iPhone/i) || stringWithPlatform.match(/iPod/i)) {
    return true;
  }

  // The new iPad return MacIntel as platform and Macintosh as userAgent
  // so the way to differentiate iPad vs mac is by checking if
  // Touch Events exist on the document
  if (stringWithPlatform.match(/Mac/i) && 'ontouchend' in document) {
    return true;
  }

  return false;
}

// TODO : return an object with all usefull info of the device for debugging purpose.
function _getDebugPlatformInfo() {
  console.log(window.navigator.userAgent);
  console.log(window.navigator.platform);
  return {
    userAgent: window.navigator.userAgent,
    platform: window.navigator.platform,
    _getStringWithPlatform: _getStringWithPlatform(),
    getIsIOS: getIsIOS()
  };
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SUPPORTED_FACING_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACING_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SUPPORTED_IMAGE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMAGE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORMAT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NO_CONSTRAINTS; });
var _FORMAT_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// camera constants
var USER = 'user';
var ENVIRONMENT = 'environment';

var SUPPORTED_FACING_MODES = [USER, ENVIRONMENT];

var FACING_MODES = {
  'USER': USER,
  'ENVIRONMENT': ENVIRONMENT
};

// Image constants
var PNG = 'png';
var JPG = 'jpg';

var SUPPORTED_IMAGE_TYPES = [JPG, PNG];

var IMAGE_TYPES = {
  'PNG': PNG,
  'JPG': JPG
};

var FORMAT_TYPES = (_FORMAT_TYPES = {}, _defineProperty(_FORMAT_TYPES, JPG, 'image/jpeg'), _defineProperty(_FORMAT_TYPES, PNG, 'image/png'), _FORMAT_TYPES);

var NO_CONSTRAINTS = {
  audio: false,
  video: true
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CameraPhoto__ = __webpack_require__(0);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FACING_MODES", function() { return __WEBPACK_IMPORTED_MODULE_0__CameraPhoto__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IMAGE_TYPES", function() { return __WEBPACK_IMPORTED_MODULE_0__CameraPhoto__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_getDebugPlatformInfo", function() { return __WEBPACK_IMPORTED_MODULE_0__CameraPhoto__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins__ = __webpack_require__(8);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "downloadPhoto", function() { return __WEBPACK_IMPORTED_MODULE_1__plugins__["a"]; });




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__CameraPhoto__["a" /* CameraPhoto */]);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaServices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var MediaServices = function () {
  function MediaServices() {
    _classCallCheck(this, MediaServices);
  }

  _createClass(MediaServices, null, [{
    key: 'getDataUri',
    value: function getDataUri(videoElement, config) {
      var sizeFactor = config.sizeFactor,
          imageType = config.imageType,
          imageCompression = config.imageCompression,
          isImageMirror = config.isImageMirror;
      var videoWidth = videoElement.videoWidth,
          videoHeight = videoElement.videoHeight;

      var _getImageSize = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["c" /* getImageSize */])(videoWidth, videoHeight, sizeFactor),
          imageWidth = _getImageSize.imageWidth,
          imageHeight = _getImageSize.imageHeight;

      // Build the canvas size et draw the image to context from videoElement


      var canvas = document.createElement('canvas');
      canvas.width = imageWidth;
      canvas.height = imageHeight;
      var context = canvas.getContext('2d');

      // Flip horizontally (as css transform: rotateY(180deg))
      if (isImageMirror) {
        context.setTransform(-1, 0, 0, 1, canvas.width, 0);
      }

      context.drawImage(videoElement, 0, 0, imageWidth, imageHeight);

      // Get dataUri from canvas
      var dataUri = Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* getDataUri */])(canvas, imageType, imageCompression);
      return dataUri;
    }
  }, {
    key: 'getWindowURL',
    value: function getWindowURL() {
      var windowURL = window.URL || window.webkitURL || window.mozURL || window.msURL;
      return windowURL;
    }

    /*
    Inspiration : https://github.com/jhuckaby/webcamjs/blob/master/webcam.js
    */

  }, {
    key: 'getNavigatorMediaDevices',
    value: function getNavigatorMediaDevices() {
      var NMDevice = null;
      var isNewAPI = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
      var isOldAPI = !!(navigator.mozGetUserMedia || navigator.webkitGetUserMedia);

      if (isNewAPI) {
        NMDevice = navigator.mediaDevices;
      } else if (isOldAPI) {
        var NMDeviceOld = navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
        // Setup getUserMedia, with polyfill for older browsers
        // Adapted from: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia

        var polyfillGetUserMedia = {
          getUserMedia: function getUserMedia(constraint) {
            return new Promise(function (resolve, reject) {
              NMDeviceOld.call(navigator, constraint, resolve, reject);
            });
          }
        };

        // Overwrite getUserMedia() with the polyfill
        NMDevice = Object.assign(NMDeviceOld, polyfillGetUserMedia);
      }

      // If is no navigator.mediaDevices || navigator.mozGetUserMedia || navigator.webkitGetUserMedia
      // then is not supported so return null
      return NMDevice;
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/Media_Streams_API/Constraints

  }, {
    key: 'isSupportedFacingMode',
    value: function isSupportedFacingMode() {
      // navigator.mediaDevices
      return MediaServices.getNavigatorMediaDevices().getSupportedConstraints().facingMode;
    }
  }, {
    key: 'getIdealConstraints',
    value: function getIdealConstraints(idealCameraDevice, idealResolution) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__helper__["e" /* hasConstraints */])(idealCameraDevice, idealResolution)) {
        return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NO_CONSTRAINTS */];
      }

      var supConstraints = MediaServices.getNavigatorMediaDevices().getSupportedConstraints();
      if (!supConstraints.width || !supConstraints.height) {
        console.error('Constraint width or height not supported! fallback to default resolution');
        return __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NO_CONSTRAINTS */];
      }

      var facingMode = void 0;
      var deviceId = void 0;

      if (idealCameraDevice) {
        var isFacingMode = __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* SUPPORTED_FACING_MODES */].includes(idealCameraDevice);
        if (isFacingMode) {
          facingMode = idealCameraDevice;
        } else {
          deviceId = { exact: idealCameraDevice };
        }
      }

      var width = idealResolution && idealResolution.width;
      var height = idealResolution && idealResolution.height;

      return {
        audio: false,
        video: {
          facingMode: facingMode,
          deviceId: deviceId,
          width: width,
          height: height
        }
      };
    }
  }, {
    key: 'getMaxResolutionConstraints',
    value: function getMaxResolutionConstraints() {
      var idealCameraDevice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var numberOfMaxResolutionTry = arguments[1];

      console.warn('getMaxResolutionConstraints() numberOfMaxResolutionTry:', numberOfMaxResolutionTry);

      var VIDEO_ADVANCED_CONSTRANTS = [{ width: { min: 640 } }, { width: { min: 800 } }, { width: { min: 900 } }, { width: { min: 1024 } }, { width: { min: 1080 } }, { width: { min: 1280 } }, { width: { min: 1920 } }, { width: { min: 2560 } }, { width: { min: 3840 } }];

      var stdConstraints = MediaServices.getIdealConstraints(idealCameraDevice, {});

      if (numberOfMaxResolutionTry === 0) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__helper__["d" /* getIsIOS */])()) {
          console.warn('fallback to iOS constraints');
          // inspiration : https://www.w3.org/TR/mediacapture-streams/#example-3
          var iPhoneConstraints = MediaServices.getIdealConstraints(idealCameraDevice, {
            width: { min: 640, ideal: 3840 },
            height: { min: 480, ideal: 2160 }
          });
          return iPhoneConstraints;
        }

        stdConstraints.video.advanced = VIDEO_ADVANCED_CONSTRANTS;
        return stdConstraints;
      }

      if (numberOfMaxResolutionTry < VIDEO_ADVANCED_CONSTRANTS.length) {
        // Each number of try, we remove the last value of the array (the bigger minim width)
        var advanced = VIDEO_ADVANCED_CONSTRANTS.slice(0, -numberOfMaxResolutionTry);
        stdConstraints.video.advanced = advanced;
        return stdConstraints;
      }

      // Fallback all the possibility has been tried. ie:.
      // numberOfMaxResolutionTry >= VIDEO_ADVANCED_CONSTRANTS.length
      return null;
    }
  }, {
    key: 'FACING_MODES',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FACING_MODES */];
    }
  }, {
    key: 'IMAGE_TYPES',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* IMAGE_TYPES */];
    }
  }]);

  return MediaServices;
}();

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CameraPhoto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MediaServices__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(7);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var DEFAULT_IMAGE_TYPE = __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a" /* MediaServices */].IMAGE_TYPES.PNG;

var CameraPhoto = function () {
  function CameraPhoto(videoElement) {
    _classCallCheck(this, CameraPhoto);

    this.videoElement = videoElement;
    this.stream = null;
    this.numberOfMaxResolutionTry = 0;
    this.settings = null;
    this.cameras = [];

    // Set the right object depending on the browser.
    this.windowURL = __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a" /* MediaServices */].getWindowURL();
    this.mediaDevices = __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a" /* MediaServices */].getNavigatorMediaDevices();
  }

  _createClass(CameraPhoto, [{
    key: '_getStreamDevice',
    value: function _getStreamDevice(idealCameraDevice, idealResolution) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var constraints = __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a" /* MediaServices */].getIdealConstraints(idealCameraDevice, idealResolution);

        _this.mediaDevices.getUserMedia(constraints).then(function (stream) {
          _this._gotStream(stream);
          resolve(stream);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: '_getStreamDeviceMaxResolution',
    value: function _getStreamDeviceMaxResolution(idealCameraDevice) {
      var _this2 = this;

      var constraints = __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a" /* MediaServices */].getMaxResolutionConstraints(idealCameraDevice, this.numberOfMaxResolutionTry);

      // all the trying is done...
      if (constraints == null) {
        var idealResolution = {};
        return this._getStreamDevice(idealCameraDevice, idealResolution);
      }

      return new Promise(function (resolve, reject) {
        _this2.mediaDevices.getUserMedia(constraints).then(function (stream) {
          _this2._gotStream(stream);
          resolve(stream);
        }).catch(function (error) {
          setTimeout(function () {
            _this2.numberOfMaxResolutionTry += 1;
            _this2._getStreamDeviceMaxResolution(idealCameraDevice).catch(function () {
              reject(error);
            });
          }, 20);
        });
      });
    }
  }, {
    key: '_setVideoSrc',
    value: function _setVideoSrc(stream) {
      if ('srcObject' in this.videoElement) {
        this.videoElement.srcObject = stream;
      } else {
        // using URL.createObjectURL() as fallback for old browsers
        var videoSrc = this.windowURL.createObjectURL(stream);
        this.videoElement.src = videoSrc;
      }
    }
  }, {
    key: '_setSettings',
    value: function _setSettings(stream) {
      // default setting is null
      this.settings = null;
      var tracks = stream && stream.getTracks ? stream.getTracks() : [];

      if (tracks.length > 0 && tracks[0].getSettings) {
        this.settings = tracks[0].getSettings();
      }
    }
  }, {
    key: '_enumerateCamerasPromise',
    value: function _enumerateCamerasPromise() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        // only make shure the camera is sarted

        var cameras = [];
        _this3.mediaDevices.enumerateDevices().then(function (devices) {
          devices.forEach(function (device) {
            if (device.kind === 'videoinput' && device.deviceId) {
              cameras.push(device);
            }
          });
          resolve(cameras);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: '_gotStream',
    value: function _gotStream(stream) {
      this.stream = stream;
      this._setSettings(stream);
      this._setVideoSrc(stream);
    }
  }, {
    key: 'getCameraSettings',
    value: function getCameraSettings() {
      return this.settings;
    }
  }, {
    key: 'enumerateCameras',
    value: function enumerateCameras() {
      var _this4 = this;

      // If the camera is already started, return only the promise.
      if (this.stream) {
        return this._enumerateCamerasPromise();
      }

      // We don't know if the camera is granted so we need to start
      // and stop the camera and then return the promise.
      return this.stopCamera().then(function () {}).catch(function () {}).then(function () {
        var constraints = { video: true };
        return _this4.mediaDevices.getUserMedia(constraints).then(function (stream) {
          // Wait 20 ms before stop the camera.
          setTimeout(function () {
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
          }, 20);
        }).then(function () {}).catch(function () {}).then(function () {
          return _this4._enumerateCamerasPromise();
        });
      });
    }
  }, {
    key: 'startCamera',
    value: function startCamera(idealCameraDevice, idealResolution) {
      var _this5 = this;

      // stop the stream before playing it.
      return this.stopCamera().then(function () {}).catch(function () {})
      // Always called (when the promise is done)
      .then(function () {
        return _this5._getStreamDevice(idealCameraDevice, idealResolution);
      });
    }
  }, {
    key: 'startCameraMaxResolution',
    value: function startCameraMaxResolution() {
      var _this6 = this;

      var idealCameraDevice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.numberOfMaxResolutionTry = 0;
      // stop the stream before playing it.
      return this.stopCamera().then(function () {}).catch(function () {})
      // Always called (when the promise is done)
      .then(function () {
        return _this6._getStreamDeviceMaxResolution(idealCameraDevice);
      });
    }
  }, {
    key: 'getDataUri',
    value: function getDataUri(userConfig) {
      var config = {
        sizeFactor: userConfig.sizeFactor === undefined ? __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* DEFAULT_SIZE_FACTOR */] : userConfig.sizeFactor,
        imageType: userConfig.imageType === undefined ? DEFAULT_IMAGE_TYPE : userConfig.imageType,
        imageCompression: userConfig.imageCompression === undefined ? __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DEFAULT_IMAGE_COMPRESSION */] : userConfig.imageCompression,
        isImageMirror: userConfig.isImageMirror === undefined ? __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DEFAULT_IMAGE_MIRROR */] : userConfig.isImageMirror
      };

      var dataUri = __WEBPACK_IMPORTED_MODULE_0__MediaServices__["a" /* MediaServices */].getDataUri(this.videoElement, config);
      return dataUri;
    }
  }, {
    key: 'stopCamera',
    value: function stopCamera() {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        if (_this7.stream) {
          _this7.stream.getTracks().forEach(function (track) {
            track.stop();
          });
          _this7.videoElement.src = '';
          _this7.stream = null;
          _this7._setSettings(null);
          resolve();
        }
        reject(Error('no stream to stop!'));
      });
    }
  }]);

  return CameraPhoto;
}();

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_SIZE_FACTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_IMAGE_COMPRESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_IMAGE_MIRROR; });
var DEFAULT_SIZE_FACTOR = 1;
var DEFAULT_IMAGE_COMPRESSION = null;
var DEFAULT_IMAGE_MIRROR = false;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__downloadPhoto__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__downloadPhoto__["a"]; });


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = downloadPhoto;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CameraPhoto__ = __webpack_require__(0);


function _dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  var blob = new Blob([ab], { type: mimeString });
  return blob;
}

function _padWithZeroNumber(number, width) {
  number = number + '';
  return number.length >= width ? number : new Array(width - number.length + 1).join('0') + number;
}

function _getFileExtention(blobType) {
  // by default the extention is .png
  var extention = __WEBPACK_IMPORTED_MODULE_0__CameraPhoto__["c" /* IMAGE_TYPES */].PNG;

  if (blobType === 'image/jpeg') {
    extention = __WEBPACK_IMPORTED_MODULE_0__CameraPhoto__["c" /* IMAGE_TYPES */].JPG;
  }
  return extention;
}

function _getFileName(prefixName, imageNumber, blobType) {
  var photoNumber = _padWithZeroNumber(imageNumber, 4);
  var extention = _getFileExtention(blobType);

  return prefixName + '-' + photoNumber + '.' + extention;
}

function _downloadImageFileFomBlob(blob, prefixName, imageNumber) {
  window.URL = window.webkitURL || window.URL;

  var anchor = document.createElement('a');
  anchor.download = _getFileName(prefixName, imageNumber, blob.type);
  anchor.href = window.URL.createObjectURL(blob);
  var mouseEvent = document.createEvent('MouseEvents');
  mouseEvent.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
  anchor.dispatchEvent(mouseEvent);
}

function downloadPhoto(dataUri) {
  var prefixName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'photo';
  var imageNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var blob = _dataURItoBlob(dataUri);
  _downloadImageFileFomBlob(blob, prefixName, imageNumber);
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// jslib-html5-camera-photo.min.js